export default __webpack_public_path__ + "static/media/random-solid.5f025153.svg";